
export const KidsNav=()=>{

    return(
      <div
      className="ddown"
      style={{
        marginLeft: "-150px",
      }}
    >
      <a href="/kids">
        <div className="flex">
        <div className="a1 k">
        <ul>
        <li>Boys Clothing</li>
        <li>T-Shirts</li>
        <li>Shirts</li>
        <li>Shorts</li>
        <li>Jeans</li>
        <li>Trousers</li>
        <li>Clothing Sets</li>
        <li>Ethnic Wear</li>
        <li>Track Pants & Pyjamas</li>
        <li>Jacket, Sweater & Sweatshirts</li>
        <li>Party Wear</li>
        <li>Innerwear & Thermals</li>
        <li>Nightwear & Loungewear</li>
        <li>Value Packs</li>
      </ul>
        </div>
        <div className="a2 k">
        <ul>
        <li>Girls Clothing</li>
        <li>Dresses</li>
        <li>Tops</li>
        <li>T-shirts</li>
        <li>Clothing Sets</li>
        <li>Lehenga choli</li>
        <li>Kurta Sets</li>
        <li>Party wear</li>
        <li>Dungarees & Jumpsuits</li>
        <li>Skirts & shorts</li>
        <li>Tights & Leggings</li>
        <li>Jeans, Trousers & Capris</li>
        <li>Jacket, Sweater & Sweatshirts</li>
        <li>Innerwear & Thermals</li>
        <li>Nightwear & Loungewear</li>
        <li>Value Packs</li>
      </ul>
        </div>
        <div className="a1 k">
        <ul>
        <li>Footwear</li>
        <li>Casual Shoes</li>
        <li>Flipflops</li>
        <li>Sports Shoes</li>
        <li>Flats</li>
        <li>Sandals</li>
        <li>Heels</li>
        <li>School Shoes</li>
        <li>Socks</li>
      </ul>
  
      <ul className="nextul k">
        <li>Toys</li>
        <li>Learning & Development</li>
        <li>Activity Toys</li>
        <li>Soft Toys</li>
        <li>Action Figure / Play set</li>
      </ul>
        </div>
        <div className="a2 k">
        <ul>
        <li>Infants</li>
        <li>Bodysuits</li>
        <li>Rompers & Sleepsuits</li>
        <li>Clothing Sets</li>
        <li>Tshirts & Tops</li>
        <li>Dresses</li>
        <li>Bottom wear</li>
        <li>Winter Wear</li>
        <li>Innerwear & Sleepwear</li>
        <li>Infant Care</li>
      </ul>
  
      <ul className="nextul k">
        <li>Home & Bath</li>
      </ul>
      <ul className="nextul k">
        <li>Personal Care</li>
      </ul>
        </div>
        <div
          className="a1 k"
          style={{
            paddingRight: "25px",
          }}
        >
          <ul>
        <li>Kids Accessories</li>
        <li>Bags & Backpacks</li>
        <li>Watches</li>
        <li>Jewellery & Hair accessory</li>
        <li>Sunglasses</li>
        <li>Masks & Protective</li>
        <li>Caps & Hats</li>
      </ul>
  
      <ul className="nextul k">
        <li>Brands</li>
        <li>H&M</li>
        <li>Max Kids</li>
        <li>Pantaloons</li>
        <li>United Colors Of Benetton Kids</li>
        {/* <li>YK</li> */}
        <li>U.S. Polo Assn. Kids</li>
        <li>Mothercare</li>
        <li>HRX</li>
      </ul>
        </div>
      </div>
      </a>
    </div>
    )
}